import { useEffect } from 'react'

const PAGE_TITLE = 'Templo de Ayuda Esotérica | Orientación espiritual en Miami, FL'
const PAGE_DESCRIPTION =
  'Orientación espiritual y prácticas esotéricas tradicionales con atención personalizada y confidencial en Miami, Florida. Consulta por WhatsApp o teléfono.'

export function usePageMeta(): void {
  useEffect(() => {
    document.title = PAGE_TITLE

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'description'
      document.head.appendChild(meta)
    }
    meta.content = PAGE_DESCRIPTION

    document.documentElement.lang = 'es'
  }, [])
}
